export default "__VITE_ASSET__i$aY8g$9__"